// extracted by mini-css-extract-plugin
export default {"meal":"Item_meal__IsuGO","description":"Item_description__-vR+V","price":"Item_price__KiZoz"};